import { Vue, Component } from 'vue-property-decorator';

@Component
export class IViewMixin extends Vue {
  $Message: any;
  $Modal: any;
  $Notice: any;
}
